import React from 'react'
import ReactPlayer from 'react-player'

import { DEFAULT_CONFIG } from './constants'

export const VideoPlayer = ({ url, config = DEFAULT_CONFIG }) => (
  <ReactPlayer url={url} width={null} height={null} config={config} controls />
)
